export const INCH_TO_MM_CONVERSION_FACTOR = 25.4;
export const millimeterWidth = 'mm W';
export const millimeterHeight = 'mm H';
export const millimeterDepth = 'mm D';
export const inchWidth = 'in W';
export const inchHeight = 'in H';
export const inchDepth = 'in D';
